<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Profile</li>
      </ol>
      <div class="emp-button btn-align text-right" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
        <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary">Create
          New Employee
        </button>
      </div>
    </div>
    <div class="main-box two-column">
      <employee-sidebar v-bind:employeeData="employeeId"></employee-sidebar>
      <div class="emplyee-info-wrp p-0 bg-transparent">
        <div class="main-box hour-head-info">
          <div class="text-wrapper">
            <div class="hour-list">
              <div class=" list-col">
                <span class="lable-text">Name</span>
                <strong class="col-blue">{{ employeeId.name }}</strong>
              </div>
              <div class=" list-col">
                <span class="lable-text">Date</span>
                <date-picker v-model="range" lang="en" format="YYYY-MM-DD" range @change="onChangeDate($event)">
                  <template v-slot:footer="{ emit }">
                        <span style="text-align: left;float: left;">
                          <button class="btn mx-btn mx-btn-text dateBtn"
                                  @click="getDateByMonth($event,emit,'lastMonth')">Last Month</button>
                          <button class="btn mx-btn mx-btn-text dateBtn dateActive"
                                  @click="getDateByMonth($event,emit,'currentMonth')">Current Month</button>
                          <button class="btn mx-btn mx-btn-text dateBtn"
                                  @click="getDateByMonth($event,emit,'nextMonth')">Next Month</button>
                          <button class="btn mx-btn mx-btn-text dateBtn"
                                  @click="getDateByMonth($event,emit,'twoMonths')">Next Two Month</button>
                        </span>
                  </template>
                </date-picker>
              </div>
              <div class=" list-col">
                <span class="lable-text">Work Days</span>
                <span>{{ countofDays }}</span>
              </div>
              <div class=" list-col">
                <span class="lable-text">Work Hours</span>
                <span>{{ totalhours }} </span>
              </div>
              <div class=" list-col mark-col">
                <span class="lable-text">Location</span>
                <a href="javascript:void(0);" @click="allAttendanceMap">
                  <i class="fas fa-map-marked-alt"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="table-scroll">
          <table class="table">
            <thead class="table-head">
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Schedule Time</th>
              <th scope="col">Attended</th>
              <th scope="col">Hours</th>
              <th scope="col">map</th>
            </tr>
            </thead>
            <tbody>
            <tr v-show="loadingSpin">
              <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
            </tr>
            <tr v-show="hoursNotFound && loadingSpin == false">
              <td :colspan="6" class="text-center">No data found</td>
            </tr>
            <tr v-for="(attendance,indx) in empAttend" :key="attendance.id">
              <td>
                <span v-if="'emptyKey' in attendance"></span>
                <span v-else>
                  {{ moment(attendance.punch_in_time).format("DD-MMM-YYYY") }}
                </span>
              </td>
              <td>
                {{ moment(attendance.schedule.start_time, 'HH:mm:ss').format('HH:mm') }} -
                {{ moment(attendance.schedule.end_time, 'HH:mm:ss').format('HH:mm') }}
              </td>
              <td>
                {{ moment(attendance.punch_in_time).format("HH:mm") }} -
                <span v-if="attendance.punch_out_time === null">--:--</span>
                <span v-else>
                  {{ moment(attendance.punch_out_time).format("HH:mm") }}
                </span>
              </td>
              <td>
                <span v-if="attendance.punch_out_time === null">--:--</span>
                <span v-else>{{ diff[indx] }}</span>
              </td>
              <td class="text-center">
                <a href="javascript:void(0);" @click="showAttendanceLocation(attendance)">
                  <i class="fas fa-map-marker-alt"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- attendance location modal -->
      <div
        class="modal fade write-msg-model creat-employee-modal"
        id="location-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="write-msg-modelLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title">
                <h5>Attendance Location</h5>
                <p class="gray-text">

                </p>
              </div>
              <button
                type="button"
                class="close"
                ref="closeModal"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span class="ico-cross"></span>
              </button>
            </div>
            <div class="modal-body">
              <div class="scrolling">
                <div class="inputs-wrapper">
                  <div id="mapp"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <createEmployeeModal></createEmployeeModal>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import employeeSidebar from "../Employees/employeeSidebar";
import createEmployeeModal from "../Employees/createEmployeeModal";
import moment from 'moment'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

export default {
  name: "employeeHours",
  components: {
    createEmployeeModal,
    DatePicker,
    employeeSidebar,
    ClipLoader
  },
  data() {
    return {
      employeeId: this.$store.getters.getEmployeeProfileId,
      employee: [],
      selectedCompany: this.$store.getters.getSelectedCompany,
      range: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      ],
      employee_name: "",
      from_date: "",
      to_date: "",
      empId: "",
      totalhours: 0,

      totalMinutes: 0,
      countofDays: 0,
      form: {
        from_date: "",
        to_date: "",
        employee_id: "",
      },
      empAttend: [],
      allAttendances: [],
      startDate: "",
      endDate: "",
      diff: [],
      size: '25px',
      spinnerColor: '#00779C',
      loadingSpin: false,
      hoursNotFound: false,
      map:null,
      allLocations:[],
      markersPathAttaching:'',
      markers :[],
      user:this.$store.getters.getUser
    }
  },
  mounted() {
    this.$root.$emit("activeCompoClick");
    this.employee_id  = this.$route.params.id || '';
    var date          = new Date();
    this.startDate    = moment().startOf('month').format('YYYY-MM-DD');
    this.endDate      = moment().endOf('month').format('YYYY-MM-DD');
    this.attendanceData();
    this.initMap();
  },
  methods: {
    showAttendanceLocation(attendance){
      this.allLocations = [];
      this.allLocations.push(attendance);
      this.loadMarkers();
    },
    allAttendanceMap(){
      let dataArr       = [];
      this.allLocations = [];
      Object.values(this.allAttendances).map((atd) => {
        dataArr.push(...atd);
      });
      this.allLocations = dataArr;
      this.loadMarkers();
    },
    loadMarkers() {
      let map                   = this.map;
      const inImage             = require('@/assets/images/in_unselected.svg');
      const inImageSelected     = require('@/assets/images/in_selected.svg');
      let markersArr            = [];
      this.markers.forEach(function (mkr) {mkr.setMap(null)});
      this.allLocations.forEach(function (loc) {
        let myLatLng = {
            lat: parseFloat(loc.latitude),
            lng: parseFloat(loc.longitude)
          };
          let marker = new google.maps.Marker({
            position: myLatLng,
            map,
            icon: inImage,
            animation: google.maps.Animation.DROP
          });
          markersArr.push(marker);
          const infoWindow = new google.maps.InfoWindow();
          marker.addListener("click", () => {
            marker.setIcon(inImageSelected);
            let start   = moment(loc.punch_in_time, "YYYY-MM-DD HH:mm:ss");
            let end     = (loc.punch_out_time) ? moment(loc.punch_out_time, "YYYY-MM-DD HH:mm:ss") : null;
            let timeDef = '';
            if(end){
              var hours   = end.diff(start, 'hours');
              var minutes = moment.utc(moment(end, "HH:mm:ss").diff(moment(start, "HH:mm:ss"))).format("mm");
              timeDef     = `${hours}:${minutes}`;
            }else{
              timeDef = '--:--';
            }
            let text = `<div style="text-align: left !important;">
              <strong>Date:</strong> ${moment(loc.punch_in_time).format('DD-MMM-YYYY')}<br>
              <strong>Punch In Time:</strong> ${moment(loc.punch_in_time).format('hh:mm a')}<br>
              <strong>Punch Out Time:</strong> ${(loc.punch_out_time) ? moment(loc.punch_out_time).format('hh:mm a') :'--:--'}<br>
              <strong>Total Time:</strong> ${timeDef}<br>
            </div>`;
            infoWindow.setContent(text);
            infoWindow.open(marker.getMap(), marker);
          });
          google.maps.event.addListener(infoWindow,'closeclick',function(){
            marker.setIcon(inImage);
          });
      });
      this.markers = markersArr;
      $('#location-modal').modal('show');
    },
    initMap() {
      let companyLatLong = (this.selectedCompany.locations)?this.selectedCompany.locations[0]:null;
      const myLatLng = {
        lat: (companyLatLong) ? parseFloat(companyLatLong.lat) : 31.5198893,
        lng: (companyLatLong) ? parseFloat(companyLatLong.lng) : 74.3508756
      };
      this.map = new google.maps.Map(document.getElementById("mapp"), {
        zoom: 14,
        center: myLatLng,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [
              { visibility: "off" },
            ]
          }
        ]
      });
    },
    calculateHoursM(startTime, endTime, date) {
      let time = this.calculateHourMinutes(moment(startTime).format('HH:mm'), moment(endTime).format('HH:mm'), moment(date).format('YYYY-MM-DD'));
      return moment(time, 'HH:mm:ss').format('HH:mm');
    },
    checkAttendanceLocation(startTime,endTime) {

      var params = {employee_id: this.employeeId.id,company_id:this.selectedCompany.id}
      this.$axios
        .get(this.$EmployeeInfo, {
          params: params,
          headers: this.getAuthHeader()
        })
        .then(response => {
          // console.log(response.data.result);
          this.employee = response.data.result;
          this.employee_name = this.employee.info.name;
          this.employeeId.id = this.employee.info.id;
          this.attendanceData();
          // console.log('all data',this.employee);
        })
        .catch(error => {
          console.log(error);
        })
    },
    getDateByMonth(event, emit, type) {
      const start = new Date();
      const end = new Date();
      if (type === 'lastMonth') {
        const date = [
          new Date(start.getFullYear(), start.getMonth() - 1, 1),
          new Date(end.getFullYear(), end.getMonth(), 0)
        ];
        emit(date);
      } else if (type === 'currentMonth') {
        const date = [
          new Date(start.getFullYear(), start.getMonth(), 1),
          new Date(end.getFullYear(), end.getMonth() + 1, 0)
        ];
        emit(date);
      } else if (type === 'nextMonth') {
        const date = [
          new Date(start.getFullYear(), start.getMonth() + 1, 1),
          new Date(end.getFullYear(), end.getMonth() + 2, 0)
        ];
        emit(date);
      } else if (type === 'twoMonths') {
        const date = [
          new Date(start.getFullYear(), start.getMonth(), 1),
          new Date(end.getFullYear(), end.getMonth() + 2, 0)
        ];
        emit(date);
      }
      $(".dateBtn").removeClass("dateActive");
      $(event.target).addClass('dateActive');
    },
    attendance() {
      var params = {employee_id: this.employeeId.id}
      this.$axios
        .get(this.$EmployeeInfo, {
          params: params,
          headers: this.getAuthHeader()
        })
        .then(response => {
          // console.log(response.data.result);
          this.employee = response.data.result;
          this.employee_name = this.employee.info.name;
          this.employeeId.id = this.employee.info.id;
          this.attendanceData();
          // console.log('all data',this.employee);
        })
        .catch(error => {
          console.log(error);
        })
    },
    onChangeDate() {
      this.form.from_date   = moment(this.range[0]).format('YYYY-MM-DD');
      this.form.to_date     = moment(this.range[1]).format('YYYY-MM-DD');
      this.attendanceData();

    },
    attendanceData() {
      this.loadingSpin = true;
      this.empAttend = [];
      if (this.form.from_date == '') {
        var paramss = {employee_id: this.employeeId.id, from_date: this.startDate, to_date: this.endDate}
      }
      if (this.form.from_date) {
        var paramss = {employee_id: this.employeeId.id, from_date: this.form.from_date, to_date: this.form.to_date}
      }
      this.$axios
        .get(this.$EmployeeAttendance,
          {
            params: paramss,
            headers: this.getAuthHeader()
          })
        .then(response => {
          this.diff           = [];
          this.totalhours     = 0;

          this.allAttendances = response.data.result;
          let resultData      = Object.entries(this.allAttendances);
          this.countofDays    = resultData.length;

          for(let [key,val] of resultData){

            let counter = 1;
            val.map((item) => {
              let start   = moment(item.punch_in_time, "YYYY-MM-DD HH:mm:ss");
              let end     = (item.punch_out_time) ? moment(item.punch_out_time, "YYYY-MM-DD HH:mm:ss") : null;
              if(end){
                var hours   = end.diff(start, 'hours');
                var minutes = moment.utc(moment(end, "HH:mm:ss").diff(moment(start, "HH:mm:ss"))).format("mm");
                this.diff.push(`${hours}:${minutes}`);
              }else{
                this.diff.push(`00:00`);
              }
            if(counter == 1){
              this.empAttend.push(item);
            }else{
              item['emptyKey'] = null;
              this.empAttend.push(item);
            }
            if(val.length>1){counter++;}
            });
          }
          const sum           = this.diff.reduce((acc, time) => acc.add(moment.duration(time)), moment.duration());
          let minutCount      = sum.minutes() < 10 ? '0' + sum.minutes() : sum.minutes();
          this.totalhours     = [Math.floor(sum.asHours()), minutCount].join(':');
          this.loadingSpin    = false;
          this.hoursNotFound  = this.empAttend.length === 0 ? true : false;

        }).catch(error => {
          console.log(error);
        })
    },
  }
}
</script>
<style>
.mx-datepicker-range {
  width: 100% !important;
}

.dateBtn {
  color: #73879c !important;
}

.dateBtn:hover {
  color: #00779C !important;
}

.dateActive {
  color: #00779C !important;
}
#mapp{
  height: 500px !important;
}
</style>
